import './Portfolio.css';
import { portfolioData } from '../../assets/data/portfolioData';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';
import { useEffect, useLayoutEffect, useState } from 'react';
import PortfolioElement from './PortfolioElement';
import Maze2 from '../maze/Maze2';
export { css, html, forest, mongodb, nodejs, react } from '../../assets/stackLogo/index';

gsap.registerPlugin(ScrollTrigger, SplitText);

const Portfolio = ({ setHideHeader }) => {
	const [enter, setEnter] = useState(false);
	const [totalWidth, setTotalWidth] = useState(0);
	const anim = () => {
		let quote2 = document.querySelector('.portfolio-header');

		let splitSecondLine = SplitText.create(quote2, { type: 'chars' });

		gsap.fromTo(
			splitSecondLine.chars,
			{
				opacity: 0,
				color: 'white',
				// ease: 'back',
				duration: 0.3,
				stagger: 0.1,
				scale: 1.5,
				x: 100,
			},
			{
				opacity: 1,
				color: 'white',
				// ease: 'back',
				duration: 0.3,
				stagger: 0.1,
				scale: 1,
				x: 0,
			}
		);
	};
	useEffect(() => {
		const ctx = gsap.context(() => {
			enter && anim();
		});
		return () => {
			ctx.revert();
		};
	}, [enter]);

	useLayoutEffect(() => {
		
		const ctx = gsap.context(() => {
			const container = document.querySelector('.portfolio-data-container');
			const contentWrapper = document.querySelector('.portfolio-data-wrapper');

			const singleElement = contentWrapper.children[0];
			const singleElementStyle = getComputedStyle(singleElement);
			const singleElementWidth = singleElement.getBoundingClientRect().width;

			const singleElementMargins = parseFloat(singleElementStyle.marginLeft) + parseFloat(singleElementStyle.marginRight);
			const singleElementPaddings = parseFloat(singleElementStyle.paddingLeft) + parseFloat(singleElementStyle.paddingRight);
			const totalElementWidth = singleElementWidth + singleElementMargins + singleElementPaddings;
			const contentWidth = totalElementWidth * portfolioData.length;

			const scrollWidth = contentWidth - container.getBoundingClientRect().width;
			if (totalWidth !== contentWidth) {
				setTotalWidth(contentWidth);
			}
			let mm = gsap.matchMedia();
			mm.add("(min-width: 600px)", () => {
				gsap.to(contentWrapper, {
					x: `-${(543 + 80 * 2) * portfolioData.length}px`,
					ease: 'none',
					scrollTrigger: {
						trigger: container,
						start: 'top top',
						end: `${scrollWidth * 2}`,
						scrub: true,
						pin: true,
						invalidateOnRefresh: true,
						pinSpacer: true,
						anticipatePin: 4,
					},
				});

			});
		});
		return () => {
			ctx.revert();
		};
	}, [totalWidth]);

	return (
		<>
			<section
				className="portfolio-data-container"
				onMouseEnter={() => {
					setEnter(true);
				}}
			>
				<div className="portfolio-header">Projects ...</div>
				<div className="portfolio-data-wrapper">
					{portfolioData.map((site, index) => {
						if (site.title === 'Navigatio') {
							return (
								<Maze2
									key={index}
									site={site}
									index={index}
									setHideHeader={setHideHeader}
								></Maze2>
							);
						} else {
							return (
								<PortfolioElement
									key={index}
									site={site}
									index={index}
									setHideHeader={setHideHeader}
								></PortfolioElement>
							);
						}
					})}
				</div>
			</section>
		</>
	);
};

export default Portfolio;
